<header class="site-header" aria-label="Primary navigation">
  <a class="brand" href="#" aria-label="Pavillion Properties home" (click)="showHome($event)">
    <img src="/oWekDykQCw8dxeFWx7rBnaWkDAQ_4.png" alt="Pavillion Properties" />
  </a>

  <nav class="nav-links" aria-label="Main menu">
    <button type="button" (click)="pageSelected.emit('about')">About</button>
    <button type="button" (click)="pageSelected.emit('developments')">Developments</button>
    <button type="button" (click)="pageSelected.emit('insights')">News &amp; Insights</button>
    <button type="button" (click)="pageSelected.emit('content')">Content</button>
    <button type="button" (click)="pageSelected.emit('contact')">Contact us</button>
  </nav>

  <button class="header-cta" type="button" (click)="inquiryRequested.emit()">
    Inquire now
    <svg class="material-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24">
      <path d="M12 4 10.59 5.41 15.17 10H4v2h11.17l-4.58 4.59L12 20l8-8z" />
    </svg>
  </button>
  <button class="menu-button" type="button" aria-label="Open menu">
    <span></span>
    <span></span>
  </button>
</header>
